import React, { Component } from 'react';
import { Example, Properties, SourceCode } from 'examples';
import Accordion from './Accordion';
import Button from '../Button/Button';
import Menu from '../Menu/Menu';

export default class AccordionExample extends Component {

  state = {
    title: 'Accordion title',
  };

  onChange = e => this.setState(e.target.value);

  onClick = e => this.setState({
    ...this.state,
    expanded: e.target.value,
  });

  onClickToolbar = e => window.showAppInfo(e.target.dataset.key);

  render() {
    const toolbar = [
      <Button key="edit" iconName="edit" data-key="edit" onClick={this.onClickToolbar}/>,
      <Button key="copy" iconName="copy" data-key="copy" onClick={this.onClickToolbar}/>,
      <Menu key="menu">
        <Button iconName="edit" data-key="edit menu" onClick={this.onClickToolbar}>Edit</Button>
        <Button iconName="copy" data-key="copy menu" onClick={this.onClickToolbar}>Copy</Button>
      </Menu>
    ];

    return (
      <Example {...this.props}>
        <Properties defaultProps={Accordion.defaultProps} propTypes={Accordion.propTypes} propValues={this.state}
          onChange={this.onChange}/>
        <div className="accordion-container">
          <Accordion onClick={this.onClick} {...this.state} toolbar={toolbar}>
            <p>
              This content is only shown when the Accordion is expanded.
            </p>
            <p>
              The menu in the upper right corner is a custom child passed to the Accordion. You may pass any type or number of
              components to the Accordion.
            </p>
          </Accordion>
        </div>
        <SourceCode querySelector=".accordion-example .accordion-container .core-accordion"/>
      </Example>
    );
  }

}
